import React from 'react'
import {
    Link,
  } from "react-router-dom";

export const Vendors = (props) => {
    return (
        <div>
            <div className="container">

                <h3 className="mt-4 mb-3" style={{fontFamily: 'effraReg'}}>BronzeTag Vendors & Purshase Orders
            
                </h3>

                <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                        <Link to="/">Home</Link>
                    </li>
                    <li className="breadcrumb-item active" style={{fontFamily: 'effraReg'}}>Vendors & Purchase Orders</li>
                </ol>

                <div className="row">
                <div class="col-lg-12">
                    <p style={{fontFamily: 'effraReg'}}>Manage your vendors, purchase orders and returns. Track your vendor balances and payments all in one place.</p>
                </div>
                
                </div>
            
            
            
            

    
    

    

            </div>
        </div>
    )
}